import React from 'react';
import { Box } from 'housecall-ui';

import { useChangeStep } from '../hooks/useChangeStep';
import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';
import { SubCategoryType } from '../types/types';

import { CategoryCard } from './CategoryCard';
import { ScrollableContent } from './ScrollableContent';

const generateDescription = (subcategory: SubCategoryType): string => {
  return subcategory.services!.map((service) => service.name).join(', ');
};

export const SubCategoryList = () => {
  const {
    state: { category },
    dispatch,
    actions,
  } = useOnlineBookingReducer();
  const { changeStep } = useChangeStep();

  const clickHandler = (subcategory: SubCategoryType) => () => {
    dispatch(actions.selectSubCategory(subcategory));
    changeStep('services');
  };

  return (
    <ScrollableContent>
      {category?.subcategories?.map((subcategory: SubCategoryType) => {
        return (
          <Box key={subcategory.uuid}>
            <CategoryCard
              key={subcategory.uuid}
              title={subcategory.name}
              description={generateDescription(subcategory)}
              onClick={clickHandler(subcategory)}
            />
          </Box>
        );
      })}
    </ScrollableContent>
  );
};
